import http from './axios';

export default class ApproveServices {
  private readonly submit_api = '/v1/approverecord/submit';
  private readonly total_api = '/v1/supervise/alert-super-count'; // 预警总览

  constructor() {}

  async submitApprove(params: any) {
    let res: any = await http.post(this.submit_api, params);
    return res.header?.code == 200 ? true : false;
  }

  async getTotal(params?: object): Promise<any> {
    let res: any = await http.get(this.total_api, { params: params });
    return res.payload;
  }

}
